import { User } from '/src/lib/models';

/**
 * Signin
 */
export type TSigninRequest = {
  username: string;
  password: string;
};

export type TSigninResponse = User;

/**
 * Signout
 */
export type TSignoutRequest = void;

export type TSignoutResponse = void;
